import { h } from 'vue';
const slot = (s, attrs) => {
  if (typeof s == 'function') return s(attrs);
  return s;
};
var script = {
  name: 'WithSeeMore',
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      opacity: 0,
      yDown: undefined
    };
  },
  methods: {
    emit() {
      this.$emit('action');
    }
  },
  mounted() {
    this.opacity = 0.9;
  },
  render() {
    const mouseDown = e => {
      e.stopPropagation();
      if (e instanceof TouchEvent) {
        var _e$touches$;
        const touch = (_e$touches$ = e.touches[0]) !== null && _e$touches$ !== void 0 ? _e$touches$ : e.changedTouches[0];
        this.yDown = touch.clientY;
      }
    };
    const mouseUp = e => {
      e.stopPropagation();
      this.emit();
    };
    const touchMove = e => {
      var _e$touches$2;
      e.stopPropagation();
      if (!this.yDown) return;
      const touch = (_e$touches$2 = e.touches[0]) !== null && _e$touches$2 !== void 0 ? _e$touches$2 : e.changedTouches[0];
      const yDiff = this.yDown - touch.clientY;
      if (yDiff > 0) {
        this.emit();
      }
      this.yDown = undefined;
    };
    const events = {
      mouseup: mouseUp,
      touchend: mouseUp,
      touchstart: mouseDown,
      mousedown: mouseDown,
      touchmove: touchMove
    };
    const style = {
      opacity: this.opacity
    };
    const label = this.label || 'See more';
    const seeMore = h('div', {
      class: 'see-more',
      on: events
    }, [h('span', {
      class: 'see-more-icon',
      style
    }, '^'), h('span', {
      class: 'see-more-text',
      style
    }, label)]);
    return h('div', {
      class: 'see-more-wrapper'
    }, [slot(this.$slots.default), seeMore]);
  }
};
export { script as default };